import { render, staticRenderFns } from "./app.about.page.vue?vue&type=template&id=6ec909c3&scoped=true&"
import script from "./app.about.page.vue?vue&type=script&lang=js&"
export * from "./app.about.page.vue?vue&type=script&lang=js&"
import style0 from "./app.about.page.vue?vue&type=style&index=0&id=6ec909c3&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec909c3",
  null
  
)

export default component.exports